import Head from 'next/head'

interface JsonLdScriptProps {
  id: string
  content: Record<string, any>
}

export default function JsonLdScript({ id, content }: JsonLdScriptProps) {
  return (
    <Head>
      <script
        id={id}
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(content) }}
      />
    </Head>
  )
}
